// extracted by mini-css-extract-plugin
export var container = "_5u-1";
export var cornerButtonContainer = "_5u-6";
export var disabled = "_5u-2";
export var dragActive = "_5u-3";
export var fileContainer = "_5u-5";
export var hiddenInput = "_5u-4";
export var widthContainer = "_5u-0";